import CommonUtils from "@/utils/CommonUtils";
import React from "react";
import AppDialog from "../AppDialog";
import axios from "axios";
import { useTranslations } from "@/TranslationContext";
import { LuArrowLeft, LuArrowRight } from "react-icons/lu";

const RequestToPublish = ({
  uuid,
  title,
  price,
  currency,
  onClose,
  onPublish,
}: {
  uuid: string;
  title: string;
  price: number;
  currency: string;
  onClose: () => void;
  onPublish: () => void;
}) => {
  const [isPosting, setIsPosting] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [errorTitle, setErrorTitle] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const t = useTranslations();

  const publishListing = () => {
    postRequestToPublish();
  };

  const postRequestToPublish = async () => {
    setIsPosting(true);
    const url = "/api/agent-admin/post/publish-request";
    const payload = {
      uuid: uuid,
    };

    let _hasError = false;

    try {
      const response = await axios.post(url, payload);
      onPublish();
    } catch (e) {
      _hasError = true;
      setShowError(_hasError);
      setErrorTitle("Error");
      setErrorMessage("Failed to publish listing, please try again");
    }
    setIsPosting(false);
  };

  return (
    <>
      {showError && (
        <AppDialog
          type="error"
          title={errorTitle}
          text={errorMessage}
          onClose={() => {
            setShowError(false);
          }}
        />
      )}
      {isPosting && (
        <AppDialog type="loader" title="Loading" text="Please wait..." />
      )}
      {!isPosting && (
        <div className="bg-white rounded-lg text-center max-w-[400px]">
          <h2 className="text-xl font-bold text-gray-800">{title}</h2>
          <p className="mt-4 font-bold text-green-600 text-xl">
            {currency} {CommonUtils.commaSeparatedNumber(price)}
          </p>
          <p className="text-gray-600 mt-2">{t.notPublishedPostNow}</p>
          <div className="mt-4 grid place-content-center">
            <button
              onClick={publishListing}
              className=" bg-green-600 flex space-x-2 items-center text-white px-4 py-2 rounded-lg"
            >
              <span>{t.postNow}</span>
              <LuArrowRight />
            </button>
          </div>
          <div className="mt-4 grid place-content-center">
            <button
              onClick={onClose}
              className=" border flex space-x-2 items-center border-gray-600 text-gray-600 px-4 py-2 rounded-lg"
            >
              <LuArrowLeft />
              <span>{t.goBack}</span>
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default RequestToPublish;
